import React, { ReactNode } from 'react';
import './Modal.scss';
import { Modal } from 'antd';
interface propType {
  visible: boolean;
  onCancel?: (e: any) => void;
  title?: string | ReactNode;
  components: () => ReactNode;
  onClose?: () => any;
  className?: string;
  width?: string | number;
  maskClosable?: boolean;
  closable?: boolean;
}

export const TFModal: React.FC<propType> = (props) => {
  return (
    <Modal
      open={props?.visible}
      title={props?.title}
      onCancel={props?.onCancel}
      wrapClassName={`TFModelWrapper ${props?.className}`}
      width={props?.width || 800}
      footer={false}
      maskClosable={props?.maskClosable}
      closable={props?.closable}
      confirmLoading
      destroyOnClose
      afterClose={props?.onClose ? props?.onClose : undefined}
    >
      {props.components()}
    </Modal>
  );
};
